import { render, staticRenderFns } from "./CierreCaja.vue?vue&type=template&id=3877bd6b&scoped=true"
import script from "./CierreCaja.vue?vue&type=script&lang=js"
export * from "./CierreCaja.vue?vue&type=script&lang=js"
import style0 from "./CierreCaja.vue?vue&type=style&index=0&id=3877bd6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3877bd6b",
  null
  
)

export default component.exports